/* eslint-disable react/react-in-jsx-scope */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshCaptcha } from "../../actions/LoginAction";
import TextCaptcha from "../captcha/TextCaptcha";
import { ConfigurationVariable } from "../CommonEnums";

/*
 * useTextCaptcha - This hook is used for generating/showing text based captcha
 * It has below functionalities :-
 * Loading | Refreshing button for regenerating text captcha | checks captcha field whether it is valid or invalid
 * It uses TextCaptcha component for showing text based captcha with help of captchaImage and provides few callbacks
 */
const useTextCaptcha = (action) => {
    const isAutomationEnv = process.env.REACT_APP_CONFIGURATION_VARIABLE === ConfigurationVariable.Automation;
    const { isLoadingCaptcha, captchaImage } = useSelector(state => state.LoginReducer);
    const textCaptcha = isAutomationEnv ? <></> : <TextCaptcha isLoadingCaptcha={isLoadingCaptcha}
        onRefreshCaptcha={() => onRefreshCaptcha(action)}
        captchaImage={captchaImage}
        onCaptchaChange={(captcha) => onCaptchaChange(captcha)} />;

    const dispatch = useDispatch();
    const [captcha, setCaptcha] = useState(isAutomationEnv ? 'Automation Testing' : '');
    const [isCaptchaInvalid, setIsCaptchaInvalid] = useState(true);

    const onRefreshCaptcha = (action) => {
        dispatch(refreshCaptcha(action));
    }


    const onCaptchaChange = (captcha) => {
        setCaptcha(captcha);
        setIsCaptchaInvalid(!captcha);
    }

    return {
        textCaptcha,
        onRefreshCaptcha,
        isCaptchaInvalid,
        captcha,
        captchaImage
    }
};

export default useTextCaptcha;